import { addDays, isAfter } from 'date-fns';

export const isApprovalOddsTooStale = (
  lastReportRetrievalDate: string | null | undefined,
  now: Date = new Date(),
): boolean => {
  if (!lastReportRetrievalDate) {
    return false;
  }

  return isAfter(now, addDays(new Date(lastReportRetrievalDate), 30));
};
